import { HttpClient, HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { map, catchError, throwError } from 'rxjs';
import { getApiUrl, apiList } from 'src/app/core/Constants/apiList';
import { ValidationMsgs, datePicker_no_range } from 'src/app/core/Constants/static';
import { DiagnosisList } from 'src/app/core/Models/interfaces/master-management/diagnosisList';
import { InputDatepicker } from 'src/app/shared/components/datepicker_v2/interfaces/input-datepicker';
import { SharedService } from 'src/app/shared/services/shared.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { CustomValidation } from 'src/app/shared/validators/customValidators';
import { DiagnosisCodeService } from '../../services/diagnosis-code.service';
import { AllergyCodeList } from 'src/app/core/Models/interfaces/master-management/allergyCodeList';
import { AllerrgyCodeService } from '../../services/allerrgyCode.service';
import { UtilityService } from 'src/app/core/Services/utility.service';
import { UserService } from 'src/app/core/Services/user.service';
import { permission } from 'src/app/core/Constants/permissions';

@Component({
  selector: 'app-master-add-edit',
  templateUrl: './master-add-edit.component.html',
  styleUrls: ['./master-add-edit.component.css']
})
export class MasterAddEditComponent implements OnInit {
  @Output('closeAddEdit') closeAddEdit: EventEmitter<boolean> = new EventEmitter();

  @Input('isEdit') isEdit: boolean = false;
  @Input('screenType') screenType!: string;
  @Input('selectedVersion') selectedVersion!: DiagnosisList | AllergyCodeList;

  public showSlider: boolean = false;
  public isLoader: boolean = false;
  public submitted: boolean = false;
  public fileUploaded: boolean = false;
  public fileList: FileList[] = [];
  public progress: number | null = null;
  public showValidation: boolean = false;

  public validationMsg = ValidationMsgs.datePattern;
  public EndDateError = ValidationMsgs.EndDateError;
  public startDateError = ValidationMsgs.startDateError;
  public requiredMsgError = ValidationMsgs.requiredMsg;
  public startError: boolean = false;
  public validity_date_v2: InputDatepicker = datePicker_no_range;
  public commonForm!: FormGroup;
  public permissions = permission;

  public uploadFiles!: {
    form: FormGroup,
    formControl: string,
    fileSpec: {
      fileTypes: string[],
    }
  }

  constructor(
    private toasterandloader: ToasterService,
    private http: HttpClient,
    private sharedService: SharedService,
    private diagnosisCodeService: DiagnosisCodeService,
    private allergyService: AllerrgyCodeService,
    private utilityService: UtilityService,
    private userService: UserService
  ) { }

  private createForm(): void {
    this.commonForm = new FormGroup({
      version: new FormControl(null, [Validators.required]),
      // versionCode: new FormControl(null, [Validators.required]),
      validityStart: new FormControl(null, [Validators.required, CustomValidation.patternCheck, CustomValidation.checkDateWithToday]),
      validityEnd: new FormControl(null, [Validators.required, CustomValidation.patternCheck, CustomValidation.checkDateWithToday]),
      description: new FormControl(null),
      file: new FormControl(null),
    });
    this.uploadFiles = {
      form: this.commonForm,
      formControl: 'file',
      fileSpec: {
        fileTypes: ['XLSX']
      }
    }

  }

  private prefillDiagnosisForm(): void {
    const diaganosisItem = this.selectedVersion as DiagnosisList;
    this.commonForm.patchValue({
      version: diaganosisItem.diaganosisVersion,
      validityStart: diaganosisItem.activeFrom.split("-").reverse().join("/"),
      validityEnd: diaganosisItem.expiredOn.split("-").reverse().join("/"),
      description: diaganosisItem.diaganosisVersionDesc
    });
    this.commonForm.controls['version'].disable();
    this.commonForm.controls['validityStart'].disable();
    this.commonForm.controls['description'].disable();
  }

  private saveDiagnosis(): void {
    const formData = new FormData();
    if (this.commonForm.valid) {
      this.progress = 1;
      const formValues = this.commonForm.value;
      const validityStart = formValues?.validityStart?.split("/").reverse().join("-");
      const validityEndDate = formValues?.validityEnd?.split("/").reverse().join("-");
      formData.append('file', this.fileList[0]?.[0]);
      formData.append('diaganosisVersion', formValues?.version.trim());
      formData.append('validityStart', validityStart);
      formData.append('validityEnd', validityEndDate);
      formData.append('diaganosisVersionDesc', formValues.description || '');
      const endpoint = getApiUrl(apiList.diagnosis.addNewDiagnosis);
      this.uplaodFile(formData, endpoint)
    }
    else {
      this.sharedService?.scrollToFirstInvalidControl();
    }
  }

  private updateDiagnosis(): void {
    if (this.commonForm.valid) {
      this.isLoader = true;
      this.toasterandloader.isLoaderEnable(true);
      const formValues = this.commonForm.getRawValue();
      const valStart = formValues?.validityStart
      const valEnd = formValues?.validityEnd;
      const validityStart = valStart?.split("/").reverse().join("-");
      const validityEndDate = valEnd?.split("/").reverse().join("-");
      const payLoad = {
        validityStart: validityStart,
        validityEnd: validityEndDate,
      }
      const versionId = (this.selectedVersion as DiagnosisList).diaganosisVersionId;
      this.diagnosisCodeService.updateDiagnosis(payLoad, versionId).subscribe({
        next: (response => {
          if (response) {
            this.isLoader = false;
            this.toasterandloader.isLoaderEnable(false);
            this.toasterandloader.alert.toast({
              title: 'Success',
              type: 'success',
              message: "Successfully Updated"
            });
            this.closePopup();
          }

        }),
        error: (error => {
          this.isLoader = false;
          this.toasterandloader.isLoaderEnable(false);
          this.toasterandloader.alert.toast({
            title: 'Error',
            type: 'error',
            message: error.message
          });
        })
      });
    } else {
      this.sharedService?.scrollToFirstInvalidControl();
    }

  }

  private uplaodFile(formData: FormData, endpoint: string): void {
    this.http.post(endpoint, formData, { reportProgress: true, observe: "events" }).pipe(
      map((event: any) => {
        if (event.type == HttpEventType.UploadProgress) {
          this.progress = Math.round((100 / event.total) * event.loaded);
          if (this.progress == 100) {

          }
        }
        else if (event.type == HttpEventType.Response) {
          this.progress = null;
          this.isLoader = false;
          this.toasterandloader.alert.toast({
            title: 'Success',
            type: 'success',
            message: "Successfully Added"
          });

          this.closePopup();
        }
      }),
      catchError((err) => {
        this.progress = null;
        this.isLoader = false;
        this.toasterandloader.alert.toast({
          title: 'Error',
          type: 'error',
          message: err.message
        });
        return throwError(err.message);
      })
    )
      .toPromise();
  }

  private checkEndDate(): void {
    if (this.commonForm?.controls['validityStart'].value && this.commonForm?.controls['validityEnd'].value) {
      const valStart = this.commonForm?.controls['validityStart'].value?.split("/").reverse().join("-");
      const valEnd = this.commonForm?.controls['validityEnd'].value?.split("/").reverse().join("-")
      const start = valStart ? (new Date(valStart).getTime()) : null;
      const end = valEnd ? (new Date(valEnd).getTime()) : null;
      if (((start && end) && (start > end))) {
        this.startError = true;
      } else {
        this.startError = false;
      }
    }
  }

  private saveAllergy(): void {
    const formData = new FormData();
    if (this.commonForm.valid) {
      this.progress = 1;
      const formValues = this.commonForm.value;
      const validityStart = formValues?.validityStart?.split("/").reverse().join("-");
      const validityEndDate = formValues?.validityEnd?.split("/").reverse().join("-");
      formData.append('file', this.fileList[0]?.[0]);
      formData.append('allergyCodeVersion', formValues?.version.trim());
      formData.append('validityStart', validityStart);
      formData.append('validityEnd', validityEndDate);
      formData.append('allergyVersionDesc', formValues.description || '');
      const endpoint = getApiUrl(apiList.allergy.addNewAllergyCode);
      this.uplaodFile(formData, endpoint)
    }
    else {
      this.sharedService?.scrollToFirstInvalidControl();
    }
  }

  private updateAllergy(): void {
    if (this.commonForm.valid) {
      this.isLoader = true;
      this.toasterandloader.isLoaderEnable(true);
      const formValues = this.commonForm.getRawValue();
      const valStart = formValues?.validityStart
      const valEnd = formValues?.validityEnd;
      const validityStart = valStart?.split("/").reverse().join("-");
      const validityEndDate = valEnd?.split("/").reverse().join("-");
      const payLoad = {
        validityStart: validityStart,
        validityEnd: validityEndDate,
      }
      const versionId = +(this.selectedVersion as AllergyCodeList).allergyVersionId;
      this.allergyService.updateAllergy(payLoad, versionId).subscribe({
        next: (response => {
          if (response) {
            this.isLoader = false;
            this.toasterandloader.isLoaderEnable(false);
            this.toasterandloader.alert.toast({
              title: 'Success',
              type: 'success',
              message: "Successfully Updated"
            });
            this.closePopup();
          }

        }),
        error: (error => {
          this.isLoader = false;
          this.toasterandloader.isLoaderEnable(false);
          this.toasterandloader.alert.toast({
            title: 'Error',
            type: 'error',
            message: error.message
          });
        })
      });
    } else {
      this.sharedService?.scrollToFirstInvalidControl();
    }
  }

  private prefillAllergyForm() {
    const allergyItem = this.selectedVersion as AllergyCodeList;
    this.commonForm.patchValue({
      version: allergyItem.allergyVersion,
      validityStart: allergyItem.activeFrom.split("-").reverse().join("/"),
      validityEnd: allergyItem.expiredOn.split("-").reverse().join("/"),
      description: allergyItem.allergyVersionDesc
    });
    this.commonForm.controls['version'].disable();
    this.commonForm.controls['validityStart'].disable();
    this.commonForm.controls['description'].disable();
  }
  
  public ngOnInit(): void {
    this.createForm();
    if (this.isEdit) {
      if (this.screenType == 'diagnosis') {
        this.prefillDiagnosisForm()
      }
      else if (this.screenType == 'allergy') {
        this.prefillAllergyForm();
      }
    }
  }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      this.showSlider = true;
    });
  }

  public checkPermission(perName: string): boolean {
    return this.userService.getPermissions(perName);
  }

  public closePopup() {
    this.showSlider = false;
    setTimeout(() => {
      this.closeAddEdit.emit(true);
    }, 200);
  }

  public addVersion(): void {
    this.submitted = true;
    this.checkEndDate();
    if (this.startError) {
      return
    }
    if (!this.fileList?.length) {
      this.commonForm.controls['file']?.addValidators(Validators.required);
      this.commonForm.controls['file']?.updateValueAndValidity();
    }
    if (this.screenType == 'diagnosis') {
      this.saveDiagnosis();
    }
    else if (this.screenType == 'allergy') {
      this.saveAllergy();
    }

  }

  public updateVersion(): void {
    this.checkEndDate();
    if (this.startError) {
      return;
    }
    if (this.screenType == 'diagnosis' && this.checkPermission(this.permissions.diagnosis.editDiagnosis)) {
      this.updateDiagnosis();
    }
    else if (this.screenType == 'allergy' && this.checkPermission(this.permissions.allergy.editAllergy)) {
      this.updateAllergy();
    }
  }

  public invalidEndDate(): boolean {
    this.checkEndDate();
    if (this.startError) {
      return true;
    } else {
      return false;
    }
  }

  public uploadedFiles(event: FileList[]) {
    this.fileList = event;
  }

  public downloadTemplate(): void {
    this.isLoader = true;
    let endpoint = '';
    if (this.screenType == 'diagnosis') {
      endpoint = getApiUrl(apiList.diagnosis.dowloadDiagnosis);
    }
    else if (this.screenType == 'allergy') {
      endpoint = getApiUrl(apiList.allergy.dowloadAllergy);
    }

    this.http.get(endpoint, {
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', },
      responseType: 'blob', observe: 'response'
    }).pipe().subscribe({
      next: (response) => {
        this.utilityService.download(response, this.utilityService.downloadTypes.excel);
        this.isLoader = false;
      },
      error: (error) => {
        const reader = new FileReader();
        reader.onload = (e: Event) => {
          const errmsg = JSON.parse((<any>e.target).result);
          if (errmsg.message) {
            this.isLoader = false;
            this.toasterandloader.alert.toast({
              title: 'Error',
              type: 'error',
              message: errmsg.message
            });
          }
        };
        reader.readAsText(error);
      }
    });
  }

  public closeError(): void {
    this.showValidation = false;
  }

}
